module.exports = __webpack_public_path__ + "img/delivery.25166646.png";